@if (contentStore.page().group_sections && windowService.isInCompactMode()) {
<wyzeweb-mobile-accordion></wyzeweb-mobile-accordion>
} @else { @for (section of contentStore.page().sections; track $index + '-' + section.originalIndex) {
<wyzeweb-section
	ngSkipHydration
	[data]="section"
	[index]="$index"
	[modifiedDate]="contentStore.page().modified_date"
	[pageUrl]="contentStore.page().page_url"></wyzeweb-section>
} }

<div
	*ngIf="
		contentStore.page().modified_date &&
		contentStore.page().page_url &&
		!contentStore.page().page_url.startsWith('blog/')
	"
	class="page-updated-label">
	Page updated on {{ contentStore.page().modified_date | date : 'MMM d, y' }}
</div>
